export function getRowValue({ column, row }) {
  const { field, type } = column;
  const value = row[field];

  if (type === 'singleSelect' && column.valueOptions) {
    return column.valueOptions.find((option) => option.value === value)?.label || value;
  }

  if (!column.valueGetter) {
    return value;
  }

  return column.valueGetter(value, row, column);
}

export function isRowMatchingQuickFilter({ colDef, row, quickFilterValues }) {
  if (quickFilterValues.length === 0) {
    return true;
  }

  for (let i = 0; i < quickFilterValues.length; i++) {
    const filterValue = quickFilterValues[i];
    for (let j = 0; j < colDef.length; j++) {
      const column = colDef[j];
      const value = getRowValue({ column, row });
      const isMatching = String(value).includes(filterValue);

      if (isMatching) {
        return true;
      }
    }
  }

  return false;
}

export default function getMatchingRows({ colDef, rows, quickFilterValues }) {
  return rows.filter((row) => isRowMatchingQuickFilter({ colDef, row, quickFilterValues }));
}
